import { GetAccessTokenResponse, GetRefreshAccessTokenResponse } from '@shared/core/google'
import { makePublicRequest, makeRequest } from 'src/helpers/request'

export const AuthService = {
  authorize: (code: string, extraData?: Record<string, any>): Promise<GetAccessTokenResponse> => {
    const params = new URLSearchParams({ ...extraData, code })
    return makeRequest(`${import.meta.env.VITE_API_URL}/auth/getAccessToken?${params}`, 'get')
  },

  refreshToken: (refreshToken: string): Promise<GetRefreshAccessTokenResponse> => {
    return makePublicRequest(`${import.meta.env.VITE_API_URL}/auth/refreshAccessToken`, 'post', { refreshToken })
  },

  exchangeImpersonationCode: (code: string): Promise<{ access_token: string; refresh_token: string }> => {
    return makePublicRequest(`${import.meta.env.VITE_API_URL}/auth/impersonation/exchange`, 'post', { code })
  },

  exchangeConnectedAppLoginCode: (code: string): Promise<{ access_token: string; refresh_token: string }> => {
    return makePublicRequest(`${import.meta.env.VITE_API_URL}/auth/connected-app-login/exchange`, 'post', { code })
  },
}
